<template>
  <div class="tasks">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <TimeTrackingTable :isReadOnly="isReadOnly" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs';
import TimeTrackingTable from '@/components/TimeTrackingTable';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { TIME_TRACKING_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'AdminTimeTracking',
  components: {
    Breadcrumbs,
    TimeTrackingTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    /** Viewer on the view time-tracking; with the switch off every level is editor. */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(TIME_TRACKING_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('time_tracking') }];
    },
  },

  methods: {},

  async mounted() {},
};
</script>

<style scoped lang="scss"></style>
